
"use client";

import CookieConsent from "react-cookie-consent";
import Link from "next/link";

export function CookieConsentBanner() {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Only Essential" // Changed from "Decline"
      cookieName="zamzi-connect-cookie-consent"
      style={{
        background: "#FFFFFF",
        color: "hsl(var(--foreground))",
        borderTop: "1px solid hsl(var(--border))",
        boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
      }}
      buttonStyle={{
        backgroundColor: "hsl(var(--primary))",
        color: "#FFFFFF",
        fontSize: "14px",
        borderRadius: "var(--radius)",
        padding: "10px 20px",
      }}
      declineButtonStyle={{
        backgroundColor: "#A0C4FF", // Light Blue
        color: "hsl(var(--primary))",
        fontSize: "14px",
        borderRadius: "var(--radius)",
        padding: "10px 20px",
      }}
      expires={150}
      enableDeclineButton
      // Analytics is gated on this decision, not on these callbacks: see
      // components/analytics/AnalyticsProvider.tsx, which mounts GA4 only after
      // the consent cookie reads 'true'. Nothing to wire up here, and nothing
      // is sent before consent either way.
    >
      This website uses cookies to enhance the user experience. By using our site, you agree to our use of cookies.{" "}
      <Link href="/privacy-policy" className="underline" style={{ color: "hsl(var(--primary))" }}>
        Learn more in our Privacy Policy.
      </Link>
    </CookieConsent>
  );
}
